import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Navbar from "./Navbar";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Packages from "./Packages.js";
import PackageInfo from "./PackageInfo.js";
import Contact from "./Contact.js";
import About from "./About.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Navbar />
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/packages" element={<Packages />} />
      <Route path="/about" element={<About />} />
      <Route path="/package/:package" element={<PackageInfo />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
  </BrowserRouter>,
);
